import { Nullable } from "../../base-types";
import Guard from "../../guard";
import { IEntityLoadConfiguration } from "./entity-load-configuration";
import { Query } from "./query";
import { IQueryIterator } from "./query-iterator";
import { IQueryResult } from "./query-result";
import { QueryResultPagingManager } from "./query-result-paging-manager";

export abstract class LoadingQueryIteratorBase<T extends IQueryResult> implements IQueryIterator<T> {
    private readonly _query: Query;
    private readonly _loadConfiguration: IEntityLoadConfiguration;

    current: Nullable<T>;

    constructor(query: Query, loadConfiguration: IEntityLoadConfiguration, result?: T) {
        Guard.notNullOrUndefined(query);
        Guard.notNullOrUndefined(loadConfiguration);

        //TODO: Make a deep clone?
        this._query = query;
        this._loadConfiguration = loadConfiguration;

        if (result != null) {
            this.current = result;
        }
    }

    canMovePrevious(): boolean {
        return QueryResultPagingManager.canMovePrevious(this.current);
    }

    canMoveNext(): boolean {
        return QueryResultPagingManager.canMoveNext(this.current);
    }

    async movePreviousAsync(): Promise<boolean> {
        if (!this.canMovePrevious()) return false;

        this._query.skip = QueryResultPagingManager.getOffsetPreviousPage(this.current);
        this.current = await this.getResultAsync(this._query, this._loadConfiguration);

        return true;
    }

    async moveNextAsync(): Promise<boolean> {
        if (!this.canMoveNext()) return false;

        this._query.skip = QueryResultPagingManager.getOffsetNextPage(this.current);
        this.current = await this.getResultAsync(this._query, this._loadConfiguration);

        return true;
    }

    reset(): void {
        this.current = null;
    }

    abstract getResultAsync(query: Query, loadConfiguration: IEntityLoadConfiguration): Promise<T>;
}
